import { Component, Input } from '@angular/core';

type StatusLevel = 'optimal' | 'vigilance' | 'warning' | 'critical' | 'surqualite'

interface StatusConfig {
    bgColor: string
    label: string
    description: string
}


@Component({
    selector: 'app-status-badge',
    templateUrl: './status-badge.component.html',
    styleUrl: './status-badge.component.scss',
    standalone: false
})
export class StatusBadgeComponent {
  @Input() level: StatusLevel = 'optimal';
  @Input() showLabel = true;
  @Input() className = '';

  statusConfig: Record<StatusLevel, StatusConfig> = {
    surqualite: {
      bgColor: 'bg-blue-600',
      label: 'Surqualité',
      description: "> 95% d'équipements sans alarme",
    },
    optimal: {
      bgColor: 'bg-green-500',
      label: 'Optimal',
      description: '85% - 95%',
    },
    vigilance: {
      bgColor: 'bg-orange-500',
      label: 'Vigilance',
      description: '70% - 85%',
    },
    warning: {
      bgColor: 'bg-amber-500',
      label: 'Alerte',
      description: '10% - 20%',
    },
    critical: {
      bgColor: 'bg-red-600',
      label: 'Critique',
      description: '< 70%',
    },
  };

  get config() {
    return this.statusConfig[this.level];
  }
}
